<template>
  <BaseForm
    :key="producerId || 'new'"
    :title="formTitle"
    :formData="producerData"
    :fields="fields"
    :submitUrl="submitUrl"
    :method="method"
    @form-success="handleSuccess"
    @form-error="handleError"
  />
</template>

<script>
import BaseForm from './BaseForm.vue';
import axios from 'axios';

export default {
  components: {
    BaseForm
  },
  props: {
    producerId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      producerData: {
        name: '',
        address_line1: '',
        address_line2: '',
        city: '',
        state: '',
        zip_code: '',
        office_phone: '',
        contact_person: '',
        cell_phone: '',
        fax: '',
        email: '',
        producer_area_id: ''
      },
      fields: [
        { model: 'name', label: 'Name', required: true, type: 'text' },
        { model: 'address_line1', label: 'Address Line 1', type: 'text' },
        { model: 'address_line2', label: 'Address Line 2', type: 'text' },
        { model: 'city', label: 'City', type: 'text' },
        { model: 'state', label: 'State', type: 'text' },
        { model: 'zip_code', label: 'Zip Code', type: 'text' },
        { model: 'office_phone', label: 'Office Phone', type: 'text' },
        { model: 'contact_person', label: 'Contact Person', type: 'text' },
        { model: 'cell_phone', label: 'Cell Phone', type: 'text' },
        { model: 'fax', label: 'Fax', type: 'text' },
        { model: 'email', label: 'Email', type: 'email' },
        { model: 'producer_area_id', label: 'Producer Area', required: true, type: 'select', optionsUrl: '/api/v1/producer_area/producer-areas/', labelField: 'name' }
      ]
    };
  },
  computed: {
    formTitle() {
      return this.producerId ? `Edit Producer` : 'Add Producer';
    },
    submitUrl() {
      return this.producerId ? `/api/v1/producer/producers/${this.producerId}/` : '/api/v1/producer/producers/';
    },
    method() {
      return this.producerId ? 'put' : 'post';
    }
  },
  mounted() {
    if (this.producerId) {
      this.loadProducerData();
    }
  },
  methods: {
    loadProducerData() {
      axios.get(`/api/v1/producer/producers/${this.producerId}/`).then(response => {
        this.producerData = { ...response.data, producer_area_id: response.data.producer_area_id.id };
        console.log(this.producerData);
      }).catch(console.error);
    },
    handleSuccess() {
      this.$q.notify({
        color: 'green',
        position: 'top',
        message: 'Producer saved successfully!',
        icon: 'check_circle',
        timeout: 3000
      });
    },
    handleError(error) {
      console.error(error);
      this.$q.notify({
        color: 'red',
        position: 'top',
        message: 'There was a problem saving the producer!',
        icon: 'check_circle',
        timeout: 3000
      });
    }
  }
};
</script>
